export default __webpack_public_path__ + "5d47d58852b35383f99fe5192d54ab77.png";